import { Link } from 'react-router-dom';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

export function HelpHeaderButton() {
  return (
    <Link
      to="/tenant/help"
      title="Help — how to use this panel"
      aria-label="Open help center"
      className="rounded-lg p-2 text-secondary hover:bg-[var(--bg-card-hover)] hover:text-[var(--text-primary)]"
    >
      <QuestionMarkCircleIcon className="h-5 w-5" aria-hidden />
    </Link>
  );
}
